<script setup lang="ts">
import { SparklesIcon } from '@heroicons/vue/24/solid'
import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
</script>

<template>
  <div :data-testid="TEST_IDS_CREATE.textInput.sparklesIcon">
    <component
      :is="SparklesIcon"
      :data-testid="TEST_IDS_CREATE.textInput.sparklesIcon" 
      aria-hidden="true"
    />
  </div>
</template>
